function currentcartdataOnchange() {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      saveCartToCustomerMetafield(formatCartData(cart));
    })
    .catch((error) => console.error("Error fetching current cart:", error));
}

function formatCartData(cart) {
  return cart.items.map((item) => ({
    id: item.id,
    quantity: item.quantity,
  }));
}

function saveCartToCustomerMetafield(cartData) {
  const customercustomid = document.querySelector('#customer_id_customdata');
  const SHOPIFY_APP_BASE_URL_FOR_CART_CUSTOM =
    "https://multi-address-order-30436288b667.herokuapp.com/api";
  const customerId = customercustomid?.value;
  if (!customerId) return;

  const payload = {
    customer_id: customerId,
    cart_data: cartData ? JSON.stringify(cartData) : "",
  };

  fetch(`${SHOPIFY_APP_BASE_URL_FOR_CART_CUSTOM}/save-customer-cart-data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then((response) => {
      console.log("Save response:", response);
    })
    .catch((error) => console.error("Error saving cart data:", error));
}

function cartoperation(customerCartData) {
  fetch('/cart.js')
    .then((response) => {
      if (!response.ok) throw new Error("Failed to fetch cart data");
      return response.json();
    })
    .then((cart) => {
      const currentCartData = cart.items.map((item) => ({
        id: item.id,
        quantity: item.quantity,
      }));

      comparecartdata(currentCartData, customerCartData);
    })
    .catch((error) => console.error("Error fetching cart data:", error));
}

async function comparecartdata(currentCartData, customerCartData) {
  //console.log("Customer metafield cart:", customerCartData);

  if (!customerCartData || customerCartData.length === 0) {
    return;
  }

  if (currentCartData.length === 0 && customerCartData.length > 0) {
    addCartData(customerCartData);
    return;
  }
  const storedSignature = localStorage.getItem("cart_signature") || "";
  const newSignature = await generateCartSignature(customerCartData);

  if (storedSignature === newSignature) {
    return;
  }

  const customerCartMap = new Map(customerCartData.map(item => [item.id, item.quantity]));
  const currentCartMap = new Map(currentCartData.map(item => [item.id, item.quantity]));

  const missingOrUpdatedItems = customerCartData.filter(
    (item) => !currentCartMap.has(item.id) || currentCartMap.get(item.id) !== item.quantity
  );

  const extraItemsInCurrentCart = currentCartData.filter(
    (item) => !customerCartMap.has(item.id)
  );

  if (missingOrUpdatedItems.length > 0 || extraItemsInCurrentCart.length > 0) {
    mergeCartData(missingOrUpdatedItems, customerCartData);
    localStorage.setItem("cart_signature", newSignature);
  }
}

async function addCartData(customerCartData) {
  const newSignature = await generateCartSignature(customerCartData);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: customerCartData.map(item => ({
        id: item.id,
        quantity: item.quantity,
      })),
    }),
  })
    .then((response) => {
      if (response.ok) {
        afterPushCartMetaInLocalStorein(newSignature);
        refreshCartPageNDrawerUIAfterAdding();
        location.reload();
      } else {
        return response.json().then((error) => {
          console.error("Failed to add items:", error);
        });
      }
    })
    .catch((error) => console.error("Error adding items to cart:", error));
}

async function mergeCartData(differences, customerCartData) {
  const newSignature = await generateCartSignature(customerCartData);

  if (differences && differences.length > 0) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: differences.map(item => ({
          id: item.id,
          quantity: item.quantity,
        })),
      }),
    })
      .then((response) => {
        if (response.ok) {
          afterPushCartMetaInLocalStorein(newSignature);
          location.reload();
        } else {
          return response.json().then((error) => {
            console.error("Failed to merge items:", error);
          });
        }
      })
      .catch((error) => console.error("Error merging cart items:", error));
  }
}


async function generateCartSignature(cartData) {
  const sortedCartData = [...cartData].sort((a, b) => a.id - b.id);
  const encoder = new TextEncoder();
  const data = encoder.encode(JSON.stringify(sortedCartData));
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

function afterPushCartMetaInLocalStorein(newSignature) {
  localStorage.setItem("cart_signature", newSignature);
}

function refreshCartPageNDrawerUIAfterAdding() {
  console.log("Cart UI should refresh here.");
}
